import { FeatureNames } from '@swyft/ui';
import { useAppContext } from './appState';

export interface Config {
  ServerUrl: string;
  TenantId: string;
  MatomoTag: string;
}

export function getConfig(): Config {
  return {
    ServerUrl: import.meta.env.VITE_SERVER_URL as string,
    TenantId: import.meta.env.VITE_TENANT_ID as string,
    MatomoTag: import.meta.env.VITE_MATOMO_TAG as string
  };
}

export const useFeature = (featureName: FeatureNames) => {
  const {
    state: { features }
  } = useAppContext();
  const feature = features.find((f) => f.name === featureName);
  if (!feature) {
    return {
      enabled: false,
      featureConfig: null
    };
  }
  const { enabled, featureConfig } = feature;
  return { enabled, featureConfig };
};
